import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            partners: [],
            model: {
                days: ['MONDAY'],
                maxTrainings: 0,
                startAt: [],
                trainingType: "",
                trainerOnSlot: null,
                openTermsForCurrentWeek: true
            },
            currentSelectedTime: '',
            types: [],
            days: [
                {
                    key: "MONDAY",
                    value: LocService.t('day_monday'),
                },
                {
                    key: "TUESDAY",
                    value: LocService.t('day_tuesday'),
                },
                {
                    key: "WEDNESDAY",
                    value: LocService.t('day_wednesday'),
                },
                {
                    key: "THURSDAY",
                    value: LocService.t('day_thursday'),
                },
                {
                    key: "FRIDAY",
                    value: LocService.t('day_friday'),
                },
                {
                    key: "SATURDAY",
                    value: LocService.t('day_saturday'),
                },
                {
                    key: "SUNDAY",
                    value: LocService.t('day_sunday'),
                },
            ],
            isVisibleAddUserToTerm: false,
            showAddTrainerToSlot: false,
            selectedUsers: [],
            chooseUser: false,
            trainingNumbers: LocService.t('label_max_people_on_training')
        }
    },
    methods: {
        addTerm: addTerm,
        addTime: addTime,
        deleteTime: deleteTime,
        checkTimeFormat: checkTimeFormat,
        showChoseUser: showChoseUser,
        removeSelectedUser: removeSelectedUser,
        getTrainingTypes: getTrainingTypes,
        onChangeCheckBoxDay: onChangeCheckBoxDay,
        loadPartners: loadPartners,
        isChecked: isChecked
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            // _self.chooseUser = false;
            if(this.selectedUsers.filter(e => e.id === data.id).length === 0){
                _self.selectedUsers.push(data);
            }
        });
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        this.getTrainingTypes()
        if(this.showAddTrainerToSlot){
            this.loadPartners();
        }
    }
}

function addTime(){
    var isValid = checkTimeFormat(this.currentSelectedTime)
    if(!isValid){
        swal( LocService.t('label_error'), LocService.t('label_format_of_time_not_valid'), 'error')
        return;
    }
    if(!this.model.startAt.includes(this.currentSelectedTime)){
        this.model.startAt.push(''+this.currentSelectedTime);
    }
    this.currentSelectedTime = '';
}

function deleteTime(item){
    this.model.startAt = this.model.startAt.filter(e => e !== item)
}

function checkTimeFormat(time) {
    var regex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return regex.test(time);
}

function loadPartners() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function addTerm() {
    let _self = this;
    if(_self.model.days.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_term_choose_at_least_day'), 'error')
        return
    }
    if(_self.model.startAt.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_term_choose_at_least_time'), 'error')
        return
    }
    if(this.selectedUsers.length > 0){
        var usersId = [];
        this.selectedUsers.forEach(e => {
            usersId.push(e.id);
        })
        _self.model.predefinedUsers = usersId;
    }else{
        _self.model.predefinedUsers = [];
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.addTerms(_self.model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_term_added_success'), 'success')
            this.$router.push('/pre-terms');
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })

}

function showChoseUser(){
    this.chooseUser = true;
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            for(var temp in response.data) {
                _self.model.trainingType = temp
                return
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function removeSelectedUser(user){
    this.selectedUsers =  this.selectedUsers.filter(item => item.id !== user.id);
}

function onChangeCheckBoxDay(key, id) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.days.indexOf(id) < 0){
            this.model.days.push(id);
        }
    }else{
        const index = this.model.days.indexOf(id);
        if (index > -1) {
            this.model.days.splice(index, 1);
        }
    }
}

function isChecked(key) {
    return this.model.days.includes(key);
}


// WEBPACK FOOTER //
// ./src/components/Term/Add/AddTerm.js